import CreatePortfolioModal from "./CreatePortfolioModalContainer";

export default CreatePortfolioModal;
